import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const InvoicingDocumentDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'invoicing-document',
        routeParamKey: 'invoicingDocumentId',
        pageTitle: 'InvoicingDocument Details',
        backRoute: '/invoicing-documents',
        backLabel: 'Back to InvoicingDocuments',
        tabIdPrefix: 'invoicing-document',
        tabsAriaLabel: 'invoicing-document detail tabs',
        missingIdMessage: 'No invoicing-document ID provided in the URL.',
        noDataMessage: 'No invoicing-document data available. The invoicing-document might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default InvoicingDocumentDetailPage;
